<div class="row">
    <div [ngClass]="isUpload || isAddLane || isEditLane || isEditLaneError || isSetOrderTypes ? 'col-sm-6' : 'col-sm-12'">
        <kendo-grid #opportunityLanesGrid
                    [data]="gridData"
                    [sort]="gridState.sort"
                    [skip]="gridState.skip"
                    [pageSize]="gridState.take"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (detailExpand)="onGridDetailExpand($event)"
                    (detailCollapse)="onGridDetailCollapse($event)"
                    (dataStateChange)="dataStateChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <button type="button" class="btn btn-sml btn-primary" title="XLS Import" tabindex="-1" (click)="isUpload=true" *ngIf="isSetOrderTypes!=true"><i class="fas fa-file-excel text-success"></i> Import</button>
                <button type="button" class="btn btn-sml btn-primary" title="Add Single Lane" tabindex="-1" (click)="addSingleLane()" *ngIf="isSetOrderTypes!=true">Add Single Lane</button>
                <button type="button" class="btn btn-sml btn-primary" (click)="isSetOrderTypes=true" *ngIf="isSetOrderTypes!=true">Set Types</button>
                <button type="button" kendoGridExcelCommand title="Export XLS" tabindex="-1" *ngIf="searchOpportunityLanesExportList.length > 0">Export <i class="fas fa-file-excel text-success"></i></button>
            </ng-template>
            <kendo-grid-column title="Action" width="75">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.quoteOrderID > 0 && !isSetOrderTypes">
                        <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="editLane(dataItem)" *ngIf="dataItem.quoteOrderTypeAbbrev != 'RW'"><i class="fas fa-pencil-alt"></i></button>
                        <button type="button" class="btn btn-sml btn-secondary m-1" title="Email" (click)="sendEmail(dataItem)" *ngIf="searchOpportunityLanesList.length > 0"><i class="fas fa-envelope"></i></button>
                    </div>
                    <div *ngIf="dataItem.quoteOrderID == 0 && !isSetOrderTypes">
                        <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="editLaneError(dataItem)"><i class="fas fa-pencil-alt"></i></button>
                    </div>
                    <div *ngIf="isSetOrderTypes && dataItem.quoteOrderTypeAbbrev != 'RW'">
                        <input type="checkbox" (change)="toggleWonChecked(dataItem.quoteOrderID)" [checked]="isLaneSelected(dataItem.quoteOrderID)" style="cursor: pointer;margin: 10px; transform: scale(1.5);" />
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="quoteOrderID" title="Order #">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a target="_blank" [routerLink]="['/order-entry', dataItem.quoteOrderID]">{{dataItem.orderNumber}}</a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="originCityName" title="Orig City"></kendo-grid-column>
            <kendo-grid-column field="originStateAbbreviation" title="Orig ST"></kendo-grid-column>
            <kendo-grid-column field="originZip" title="Orig Zip"></kendo-grid-column>
            <kendo-grid-column field="originCountryCode" title="Orig Cntry"></kendo-grid-column>
            <kendo-grid-column field="destinationCityName" title="Dest City"></kendo-grid-column>
            <kendo-grid-column field="destinationStateAbbreviation" title="Dest ST"></kendo-grid-column>
            <kendo-grid-column field="destinationZip" title="Dest Zip"></kendo-grid-column>
            <kendo-grid-column field="destinationCountryCode" title="Dest Cntry"></kendo-grid-column>
            <!--<kendo-grid-column field="minFinalCost" title="Cost" format="{0:c}"></kendo-grid-column>-->
            <!--<kendo-grid-column field="minPrice" title="Price" format="{0:c}"></kendo-grid-column>-->

            <kendo-grid-column field="numCost" title="Opp Costs">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [ngClass]="dataItem.numCost < dataItem.numCostRequired ? 'text-danger' : 'text-success'">
                        {{dataItem.numCost}}/{{dataItem.numCostRequired}}
                    </span>
                    <!--<span matTooltip="Missing opportunity costs" class="text-danger" [matTooltipPosition]="'above'" *ngIf="dataItem.numCost < dataItem.numCostRequired">
                <i class="fas fa-2x fa-exclamation-circle"></i>
            </span>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="costToPriceLineHaul" title="Cost to Price Line Haul" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="costToPriceFuel" title="Cost to Price Fuel" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="costToPricePerMile" title="Cost to Price/mi" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="costToProtectLineHaul" title="Cost to Protect Line Haul" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="costToProtectFuel" title="Cost to Protect Fuel" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="costToProtectPerMile" title="Cost to Protect/mi" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="customerFuelSurcharge" title="Fuel Surcharge" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="baseLineHaulRate" title="Base Line Haul Rate" format="{0:c}" [width]="75"></kendo-grid-column>
            <!--<kendo-grid-column field="baseLineHaulMargin" title="Base Line Haul Margin" format="{0:p}" [width]="75"></kendo-grid-column>-->
            <kendo-grid-column field="finalNetMargin" title="Net Margin" format="{0:p}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="totalBaseRate" title="Total Customer Rate" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="totalBaseRatePerMile" title="Total Customer Rate/mi" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="miles" title="Miles"></kendo-grid-column>
            <kendo-grid-column field="quoteOrderTypeDescription" title="Type"></kendo-grid-column>
            <kendo-grid-column field="frequency" title="Freq"></kendo-grid-column>
            <kendo-grid-column field="errorMessage" title="Error">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span matTooltip="{{dataItem.errorMessage}}" class="text-danger" [matTooltipPosition]="'above'" *ngIf="dataItem.quoteOrderID == 0">
                        <i class="fas fa-2x fa-exclamation-circle"></i>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="totalNetPerOrder" title="Total Net/Order" format="{0:c}" [width]="75"></kendo-grid-column>
            <kendo-grid-column field="estimatedOrderCount" title="Est Cnt"></kendo-grid-column>
            <kendo-grid-column field="estimatedGross" title="Est Gross" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="estimatedCost" title="Est Cost" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="estimatedNet" title="Est Net" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="estimatedMargin" title="Est Margin" format="{0:p}"></kendo-grid-column>
            <kendo-grid-column field="actualOrderCount" title="Actual Cnt"></kendo-grid-column>
            <kendo-grid-column field="actualGross" title="Actual Gross" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="actualCost" title="Actual Cost" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="actualNet" title="Actual Net" format="{0:c}"></kendo-grid-column>
            <kendo-grid-column field="actualMargin" title="Actual Margin" format="{0:p}"></kendo-grid-column>
            <kendo-grid-column field="masterOrderCount" title="Master Cnt"></kendo-grid-column>
            <kendo-grid-column field="customerLaneID" title="Cust Lane ID"></kendo-grid-column>
            <kendo-grid-column field="split1CustomerCode" title="Split 1 Cust Code"></kendo-grid-column>
            <kendo-grid-column field="split2CustomerCode" title="Split 2 Cust Code"></kendo-grid-column>
            <kendo-grid-excel fileName="Customer-Opportunity-Lanes.xlsx" [fetchData]="excelExportData">
                <kendo-excelexport-column field="quoteOrderID" title="Lane Ref#"></kendo-excelexport-column>
                <kendo-excelexport-column field="customerLaneID" title="Customer Lane ID"></kendo-excelexport-column>
                <kendo-excelexport-column field="originCityST" title="Origin"></kendo-excelexport-column>
                <kendo-excelexport-column field="destinationCityST" title="Destination"></kendo-excelexport-column>
                <kendo-excelexport-column field="frequency" title="Weekly Volume"></kendo-excelexport-column>
                <kendo-excelexport-column field="miles" title="Miles"></kendo-excelexport-column>
                <kendo-excelexport-column field="baseLineHaulRate" title="Line Haul" [cellOptions]="{ format: '$0.00' }"></kendo-excelexport-column>
                <!--<kendo-excelexport-column field="costToPriceFuel" title="FSC" [cellOptions]="{ format: '$0.00' }"></kendo-excelexport-column>-->
                <kendo-excelexport-column field="customerFuelSurcharge" title="FSC" [cellOptions]="{ format: '$0.00' }"></kendo-excelexport-column>
                <kendo-excelexport-column field="totalBaseRate" title="Total Rate" [cellOptions]="{ format: '$0.00' }"></kendo-excelexport-column>
            </kendo-grid-excel>
            <div *kendoGridDetailTemplate="let dataItem" style="width:1600px;">
                <!--[kendoGridDetailTemplateShowIf]="true"-->
                <kendo-grid #loadCostGrid
                            [data]="loadCostGridData"
                            [sort]="loadCostGridState.sort"
                            [skip]="loadCostGridState.skip"
                            [pageSize]="loadCostGridState.take"
                            [sortable]="false"
                            [pageable]="false"
                            [filterable]="false"
                            [resizable]="true">
                    <kendo-grid-column field="legNumber" title="Leg #" [width]="50"></kendo-grid-column>
                    <kendo-grid-column field="carrierCode" title="Carrier 3x3" [width]="75">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                                {{dataItem.carrierCode}}
                            </a>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="originCityST" title="Origin City" [width]="100"></kendo-grid-column>
                    <kendo-grid-column field="destinationCityST" title="Destination City" [width]="100"></kendo-grid-column>
                    <kendo-grid-column field="costTypeDescription" title="Cost Type" [width]="75">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="text-success" *ngIf="dataItem.isUsedForCost">
                                <i class="fas fa-check"></i>
                            </span>
                            <span class="text-danger" *ngIf="!dataItem.isUsedForCost">
                                <i class="fas fa-times"></i>
                            </span>
                            {{dataItem.costTypeDescription}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="lineHaulCost" title="Line Haul" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="fuelCost" title="Fuel" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="totalCost" title="Total Cost" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="contractLowRate" title="DAT Min Rate" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="contractLowRatePerMile" title="DAT Min RPM" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="contractAverageRate" title="DAT Avg Rate" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="contractAverageRatePerMile" title="DAT Avg RPM" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="contractHighRate" title="DAT Max Rate" format="{0:c}" [width]="75"></kendo-grid-column>
                    <kendo-grid-column field="contractHighRatePerMile" title="DAT Max RPM" format="{0:c}" [width]="75"></kendo-grid-column>
                </kendo-grid>
            </div>
        </kendo-grid>
    </div>
    <div class="col-sm-2" *ngIf="false && isUpload != true && isAddLane != true && isEditLane != true && isEditLaneError != true">
        <div class="row">
            <div class="epi-container col">
                <h4>Action</h4>
                <button class="btn btn-sml btn-success m-2" title="XLS Import" tabindex="-1" (click)="isUpload=true" *ngIf="isSetOrderTypes!=true"><i class="fas fa-file-excel"></i> Import</button>
                <br />
                <button class="btn btn-sml btn-success m-2" title="Add Single Lane" tabindex="-1" (click)="addSingleLane()" *ngIf="isSetOrderTypes!=true">Add Single Lane</button>
                <br />
                <span *ngIf="isSetOrderTypes"><input type="checkbox" [(ngModel)]="isSelectAllLanes" [checked]="isSelectAllLanes" (click)="toggleWonChecked(0)" style="cursor: pointer;margin: 10px; transform: scale(1.5);" /> Select all</span>
                <br />
                <select name="selectedOrderTypeID" [(ngModel)]="selectedOrderTypeID" class="form-select" required *ngIf="isSetOrderTypes">
                    <option value="0">- Select Type -</option>
                    <option *ngFor="let orderType of orderTypeList" value="{{orderType.quoteOrderTypeID}}">{{orderType.abbrev}} - {{orderType.description}}</option>
                </select>
                <br />
                <button type="button" class="btn btn-sml btn-secondary m-2" (click)="isSetOrderTypes=true" *ngIf="!isSetOrderTypes">Set Types</button>
                <button type="button" class="btn btn-sml btn-primary m-2" (click)="saveOrderTypes()" *ngIf="isSetOrderTypes">Save Types</button>
                <button type="button" class="btn btn-sml btn-secondary m-2" (click)="cancelAddEdit()" *ngIf="isSetOrderTypes">Cancel</button>
                <!--<div class="text-success" *ngIf="updateOrderTypeCounter>0">Updating lane {{updateOrderTypeCounter}} of {{selectedLanes.length}}</div>-->
            </div>
        </div>
    </div>
    <div class="col" *ngIf="isSetOrderTypes">
        <input type="checkbox" name="isSelectAllLanes" id="isSelectAllLanes" [(ngModel)]="isSelectAllLanes" [checked]="isSelectAllLanes" (click)="toggleWonChecked(0)" style="cursor: pointer;margin: 10px; transform: scale(1.5);" />
        <label for="isSelectAllLanes">Select all</label>
        <br />
        <select name="selectedOrderTypeID" [(ngModel)]="selectedOrderTypeID" class="form-select" required>
            <option value="0">- Select Type -</option>
            <option *ngFor="let orderType of orderTypeList" value="{{orderType.quoteOrderTypeID}}">{{orderType.abbrev}} - {{orderType.description}}</option>
        </select>
        <br />
        <button type="button" class="btn btn-sml btn-primary m-2" (click)="saveOrderTypes()">Save Types</button>
        <button type="button" class="btn btn-sml btn-secondary m-2" (click)="cancelAddEdit()">Cancel</button>
        <!--<div class="text-success" *ngIf="updateOrderTypeCounter>0">Updating lane {{updateOrderTypeCounter}} of {{selectedLanes.length}}</div>-->
    </div>
    <div class="col-sm-3" *ngIf="isEditLaneError">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold" [ngClass]="opportunityLane.originCityID > 0 ? '' : 'text-danger'">Origin</label>
                        <city-state-zip-dropdown [parentForm]="laneForm"
                                                 [ctrlName]="'originCityCtrl'"
                                                 [placeholder]="'Select a City'"
                                                 (citySelected)="citySTChanged($event, 'origin')"
                                                 [cityID]="originCityID"
                                                 [defaultCity]="defaultOriginCity"
                                                 [isRequired]="true"></city-state-zip-dropdown>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold" [ngClass]="opportunityLane.destinationCityID > 0 ? '' : 'text-danger'">Destination</label>
                        <city-state-zip-dropdown [parentForm]="laneForm"
                                                 [ctrlName]="'destinationCityCtrl'"
                                                 [placeholder]="'Select a City'"
                                                 (citySelected)="citySTChanged($event, 'destination')"
                                                 [cityID]="destinationCityID"
                                                 [defaultCity]="defaultDestinationCity"
                                                 [isRequired]="true"></city-state-zip-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-primary" (click)="saveEditLaneError()" [disabled]="!isValidEditLaneError()">Save Lane</button>
                <button type="button" class="btn btn-secondary" (click)="cancelAddEdit()">Cancel</button>
            </div>
        </div>
    </div>
    <div class="col" *ngIf="isAddLane">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold" [ngClass]="opportunityLane.originCityID > 0 ? '' : 'text-danger'">Origin</label>
                        <city-state-zip-dropdown [parentForm]="laneForm"
                                                 [ctrlName]="'originCityCtrl'"
                                                 [placeholder]="'Select a City'"
                                                 (citySelected)="citySTChanged($event, 'origin')"
                                                 [cityID]="originCityID"
                                                 [defaultCity]="defaultOriginCity"
                                                 [isRequired]="true"></city-state-zip-dropdown>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold" [ngClass]="opportunityLane.destinationCityID > 0 ? '' : 'text-danger'">Destination</label>
                        <city-state-zip-dropdown [parentForm]="laneForm"
                                                 [ctrlName]="'destinationCityCtrl'"
                                                 [placeholder]="'Select a City'"
                                                 (citySelected)="citySTChanged($event, 'destination')"
                                                 [cityID]="destinationCityID"
                                                 [defaultCity]="defaultDestinationCity"
                                                 [isRequired]="true"></city-state-zip-dropdown>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Mode (abbr)</label>
                        <select name="modeID" [(ngModel)]="modeID" (change)="modeChanged($event)" class="form-select" [ngClass]="(modeID==0) ? 'border border-danger' : ''" required>
                            <option value="0">- Select Mode -</option>
                            <option *ngFor="let item of modeList" value="{{item.modeID}}">{{item.abbrev}} - {{item.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Equipment Class</label>
                        <select name="equipmentClassID" [(ngModel)]="equipmentClassID" (change)="equipmentClassChanged($event)" class="form-select" [ngClass]="(equipmentClassID==0) ? 'border border-danger' : ''" required>
                            <option value="0">- Select Class -</option>
                            <option *ngFor="let item of equipmentClassList" value="{{item.equipmentClassID}}">[{{item.abbreviation}}] {{item.className}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Trailer (abbr)</label>
                        <select name="trailerTypeID" [(ngModel)]="trailerTypeID" (change)="trailerTypeChanged($event)" class="form-select" [ngClass]="(trailerTypeID==0) ? 'border border-danger' : ''" required>
                            <option value="0">- Select Trailer -</option>
                            <option *ngFor="let item of trailerTypeList" value="{{item.trailerTypeID}}">{{item.abbrev}} - {{item.description}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Round Trip</label>
                        <input type="checkbox" style="margin:5px;transform:scale(1.5)" [(ngModel)]="opportunityLane.roundTrip" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Frequency</label>
                        <input type="number" class="form-control" [(ngModel)]="opportunityLane.frequency" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Internal Notes</label>
                        <kendo-textarea style="width:100%" id="internalNotes"
                                        resizable="auto"
                                        [(ngModel)]="opportunityLane.internalNotes"
                                        [value]="opportunityLane.internalNotes">
                        </kendo-textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">External Notes</label>
                        <kendo-textarea style="width:100%" id="externalNotes"
                                        resizable="auto"
                                        [(ngModel)]="opportunityLane.externalNotes"
                                        [value]="opportunityLane.externalNotes">
                        </kendo-textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-primary" (click)="saveAddLane()" [disabled]="!isValidAddLane()">Save Lane</button>
                <button type="button" class="btn btn-secondary" (click)="cancelAddEdit()">Cancel</button>
            </div>
        </div>
    </div>
    <div class="col" *ngIf="isEditLane && (searchOpportunityLane | json) != '{}'">
        <div class="row">
            <div class="col-sm-4">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Origin</label>
                        <kendo-textbox [value]="searchOpportunityLane.originCityST" [disabled]="true"></kendo-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Destination</label>
                        <kendo-textbox [value]="searchOpportunityLane.destinationCityST" [disabled]="true"></kendo-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Type</label>
                        <select name="quoteOrderTypeID" [(ngModel)]="searchOpportunityLane.quoteOrderTypeID" class="form-select" required>
                            <option value="0">- Select Type -</option>
                            <option *ngFor="let orderType of orderTypeList" value="{{orderType.quoteOrderTypeID}}">{{orderType.abbrev}} - {{orderType.description}}</option>
                        </select>
                    </div>
                </div>
                <!--<div class="row" *ngIf="false">
        <div class="col">
            <label class="fw-bold" [ngClass]="searchOpportunityLane.originCityID > 0 ? '' : 'text-danger'">Origin</label>
            <city-state-zip-dropdown [parentForm]="laneForm"
                                     [ctrlName]="'editOriginCityCtrl'"
                                     [placeholder]="'Select a City'"
                                     (citySelected)="citySTChanged($event, 'editOrigin')"
                                     [cityID]="originCityID"
                                     [defaultCity]="defaultOriginCity"
                                     [isRequired]="true"></city-state-zip-dropdown>
        </div>
    </div>
    <div class="row" *ngIf="false">
        <div class="col">
            <label class="fw-bold" [ngClass]="searchOpportunityLane.destinationCityID > 0 ? '' : 'text-danger'">Destination</label>
            <city-state-zip-dropdown [parentForm]="laneForm"
                                     [ctrlName]="'editDestinationCityCtrl'"
                                     [placeholder]="'Select a City'"
                                     (citySelected)="citySTChanged($event, 'editDestination')"
                                     [cityID]="destinationCityID"
                                     [defaultCity]="defaultDestinationCity"
                                     [isRequired]="true"></city-state-zip-dropdown>
        </div>
    </div>-->
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Frequency</label>
                        <input type="number" class="form-control" [(ngModel)]="searchOpportunityLane.frequency" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Customer Lane ID</label>
                        <input type="text" class="form-control" [(ngModel)]="searchOpportunityLane.customerLaneID" />
                    </div>
                </div>
            </div>
            <div class="col-sm-8">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Base Line Haul Rate</label>
                        <kendo-numerictextbox format="c2" [min]="0" [step]="0.01" [value]="searchOpportunityLane.baseLineHaulRate" [(ngModel)]="searchOpportunityLane.baseLineHaulRate" (valueChange)="calcRateMargin(false)" [disabled]="searchOpportunityLane.numCost != searchOpportunityLane.numCostRequired"></kendo-numerictextbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="fw-bold">Cost to Price Margin<br />(eg. enter 0.1 for 10%)</label>
                        <kendo-numerictextbox format="p" [step]="0.01" [min]="0" [max]="1" [value]="searchOpportunityLane.costToPriceMargin" [(ngModel)]="searchOpportunityLane.costToPriceMargin" (valueChange)="calcRateMargin(true)" [disabled]="searchOpportunityLane.numCost != searchOpportunityLane.numCostRequired"></kendo-numerictextbox>
                    </div>
                    <div class="col">
                        <label class="fw-bold"><br />Cost to Protect Margin</label>
                        <kendo-numerictextbox format="p" [value]="searchOpportunityLane.costToProtectMargin" [(ngModel)]="searchOpportunityLane.costToProtectMargin" [disabled]="true"></kendo-numerictextbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="fw-bold">Total Cost to Price</label>
                        <kendo-numerictextbox format="c2" [value]="searchOpportunityLane.costToPriceTotal" [(ngModel)]="searchOpportunityLane.costToPriceTotal" [disabled]="true"></kendo-numerictextbox>
                    </div>
                    <div class="col">
                        <label class="fw-bold">Total Cost to Protect</label>
                        <kendo-numerictextbox format="c2" [value]="searchOpportunityLane.costToProtectTotal" [(ngModel)]="searchOpportunityLane.costToProtectTotal" [disabled]="true"></kendo-numerictextbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <label class="fw-bold">Fuel Surcharge ($)</label>
                        <input type="number" class="form-control" [(ngModel)]="searchOpportunityLane.customerFuelSurcharge" (change)="getCustomerFuelSurcharge(true)" />
                    </div>
                    <div class="col-sm-5">
                        <label class="fw-bold">Fuel Surcharge/mi ($)</label>
                        <input type="number" class="form-control" [(ngModel)]="searchOpportunityLane.customerFuelSurchargePerMile" (change)="getCustomerFuelSurcharge(false)" />
                    </div>
                    <div class="col">
                        <label class="fw-bold">Miles</label>
                        <input type="number" class="form-control" [(ngModel)]="searchOpportunityLane.miles" [disabled]="true" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Total Customer Rate</label>
                        <kendo-numerictextbox format="c2" [value]="getTotalCustomerRate()" [disabled]="true"></kendo-numerictextbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="fw-bold">Final Cost to Price Margin</label>
                        <kendo-numerictextbox format="p" [value]="calcFinalMargin(true)" [disabled]="true"></kendo-numerictextbox>
                    </div>
                    <div class="col">
                        <label class="fw-bold">Final Cost to Protect Margin</label>
                        <kendo-numerictextbox format="p" [value]="calcFinalMargin(false)" [disabled]="true"></kendo-numerictextbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label class="fw-bold">Total Net/Order</label>
                        <kendo-numerictextbox format="c2" [value]="calcTotalNetPerOrder()" [disabled]="true"></kendo-numerictextbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="searchOpportunityLane.errorMessage && searchOpportunityLane.errorMessage.length > 0">
            <div class="col">
                <label class="fw-bold">Error</label>
                <input type="text" class="text-danger form-control" [(ngModel)]="searchOpportunityLane.errorMessage" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-primary m-2" (click)="saveEditLane()">Save Lane</button>
                <button type="button" class="btn btn-secondary m-2" (click)="cancelAddEdit()">Cancel</button>
            </div>
        </div>
    </div>
    <div class="col" *ngIf="isUpload">
        <div class="row">
            <div class="col">
                <h4>Upload Lanes</h4>
                <div class="row">
                    <div class="col p-3">
                        <input type="file" (change)="uploadFile($event)" #inputFile>
                    </div>
                </div>
                <div class="row">
                    <div class="col p-3">
                        <a href="{{baseUrl}}/templates/OpportunityImportedLanesTemplate.xlsx" target="_blank">download template</a>
                    </div>
                </div>
                <div class="row" *ngIf="!isExcelFile">
                    <div class="col text-danger fw-bold">
                        Please select an Excel file (.xls or .xlsx)
                    </div>
                </div>
                <div class="row">
                    <div class="col p-3">
                        <button type="button" class="btn btn-primary" (click)="saveUpload()">Save Lanes</button>
                        <button type="button" class="btn btn-secondary" (click)="cancelUpload()">Cancel</button>
                    </div>
                </div>
                <div class="row" *ngIf="progressTotal > 0">
                    <div class="col p-3">
                        <kendo-progressbar [value]="progressTotal" style="height:25px;"></kendo-progressbar>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12" *ngIf="isUpload || isAddLane || isEditLane || isEditLaneError">
        <kendo-grid #uploadGrid
                    [data]="opportunityLanesList"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    [resizable]="true">
            <kendo-grid-column *ngFor="" field="originCityName" title="Origin City"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="originStateAbbreviation" title="Origin ST"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="originZip" title="Origin Zip"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="originCountryCode" title="Origin Cntry"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="destinationCityName" title="Destination City"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="destinationStateAbbreviation" title="Destination ST"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="destinationZip" title="Destination Zip"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="destinationCountryCode" title="Destination Cntry"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="modeAbbreviation" title="Mode"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="trailerAbbreviation" title="Trailer"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="roundTrip" title="RT"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="frequency" title="Frequency"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="internalNotes" title="Internal Notes"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="externalNotes" title="External Notes"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="customerLaneID" title="Cust Lane ID"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="split1CustomerCode" title="Split 1 Cust Code"></kendo-grid-column>
            <kendo-grid-column *ngFor="" field="split2CustomerCode" title="Split 2 Cust Code"></kendo-grid-column>
        </kendo-grid>
    </div>
</div>
